export default {
  en: {
    title: 'Edit Company',
    subtitle: 'Change your company\'s data.',
    button: 'Save changes',
    form: {
      name: 'Business Name',
      dni: 'Tax ID',
      address: 'Address',
      country: 'Country',
      admin: 'Administrator',
      lang: 'Language',
    },
    helpers: {
      dni: 'This is the taxpayer identification number of your business.',
      address: 'Fill with the your current country, not the main headquarters.',
      country: 'Select your country not the main headquarters.',
      admin: 'This is the principal administrator who have the control over account and others administrators.',
      lang: 'This is the default language for every user, although every user can select different language of the default.',
    },
    errors: {
      name: 'Please fill with a valid name',
      dni: 'Please fill with a valid business id',
      address: 'Please fill with a valid address',
      country: 'Please select a country',
      admin: 'Please select an administrator',
      lang: 'Please select a language',
      unknown: 'Something goes wrong, please try again.',
    },
    success: 'Account modification successful',
  },
  es: {
    title: 'Modificar Empresa',
    subtitle: 'Cambie datos de su empresa.',
    button: 'Guardar cambios',
    form: {
      name: 'Nombre Empresa',
      dni: 'DNI/Tax ID',
      address: 'Dirección',
      country: 'País',
      admin: 'Administrador',
      lang: 'Idioma',
    },
    helpers: {
      dni: 'Esta es el número de identificación tributaria nacional de su negocio.',
      address: 'Complete con su país actual, no con la sede principal.',
      country: 'Seleccione su país, no la sede principal.',
      admin: 'Este es el administrador principal que tiene el control sobre la cuenta y otros administradores.',
      lang: 'Este es el idioma predeterminado para cada usuario, aunque cada usuario puede seleccionar un idioma diferente al predeterminado.',
    },
    errors: {
      name: 'Por favor complete con un nombre válido',
      dni: 'Rellene con una identificación del negocio válido',
      address: 'Por favor complete con una dirección válida',
      country: 'Por favor seleccione un país',
      admin: 'Por favor seleccione un administrador',
      lang: 'Por favor seleccione un idioma',
      unknown: 'Algo sale mal, inténtalo de nuevo.',
    },
    success: 'Los datos han sido modificados correctamente',
  },
  fr: {
    title: 'Modifier l\'entreprise',
    subtitle: 'Modifiez les informations de votre entreprise.',
    button: 'Enregistrer les modifications',
    form: {
      name: 'Nom de l\'entreprise',
      dni: 'DNI/Numéro fiscal',
      address: 'Adresse',
      country: 'Pays',
      admin: 'Administrateur',
      lang: 'Langue',
    },
    helpers: {
      dni: 'C\'est le numéro d\'identification fiscale national de votre entreprise.',
      address: 'Complétez avec votre adresse actuelle, pas le siège principal.',
      country: 'Sélectionnez votre pays, pas le siège principal.',
      admin: 'C\'est l\'administrateur principal qui a le contrôle sur le compte et les autres administrateurs.',
      lang: 'C\'est la langue par défaut pour chaque utilisateur, bien que chaque utilisateur puisse sélectionner une langue différente de la langue par défaut.',
    },
    errors: {
      name: 'Veuillez entrer un nom valide',
      dni: 'Veuillez entrer un numéro d\'identification valide',
      address: 'Veuillez entrer une adresse valide',
      country: 'Veuillez sélectionner un pays',
      admin: 'Veuillez sélectionner un administrateur',
      lang: 'Veuillez sélectionner une langue',
      unknown: 'Quelque chose s\'est mal passé, veuillez réessayer.',
    },
    success: 'Les informations ont été modifiées avec succès',
}

};
